export default "__VITE_ASSET__BRvyQqeS__"